import React, {useCallback, useMemo, useState, useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { TranslatorContext, FormattedMessage } from '@jutro/locale';
import metadata from './PolicyFarmInformationComponent.metadata.json5';
import messages from './PolicyFarmInformationComponent.messages';
import styles from './PolicyFarmInformationComponent.module.scss';
import AdditionalInterestComponent from '../../AdditionalInterestComponent/AdditionalInterestComponent';

const getFormattedInfo = (message, key, value) => {
    return (
        <FormattedMessage
            {...message}
            values={{
                [key]: value
            }}
        />
    );
};

const getCellCoverageName = (rowData) => {
    const name = rowData.name ? rowData.name : '-';
    return (
        <span>
            {name}
        </span>
    );
};

const getCellTypeName = (rowData) => {
    const scheduleType = rowData.scheduleType ? rowData.scheduleType : '-';
    return (
        <span>
            {scheduleType}
        </span>
    );
};

const getCellTypeScheduleNoOfHead = (rowData) => {
    const scheduleNoOfHead = rowData.scheduleNoOfHead ? rowData.scheduleNoOfHead : '-';
    return (
        <span>
            {scheduleNoOfHead}
        </span>
    );
};

const getCellTypeScheduleValOfHead = (rowData) => {
    const scheduleValOfHead = rowData.scheduleValOfHead ? rowData.scheduleValOfHead : '-';
    return (
        <span>
            {scheduleValOfHead}
        </span>
    );
};

const getCellCoverageLimit = (rowData) => {
    const limit = rowData.limit ? rowData.limit : '-';
    return (
        <span>
            {limit}
        </span>
    );
};

const getCellCoverageDeductible = (rowData) => {
    const deductible = rowData.deductible ? rowData.deductible : '-';
    return (
        <span>
            {deductible}
        </span>
    );
};

const getCellObSettlement = (rowData) => {
    const settlementBasis = rowData.settlementBasis ? rowData.settlementBasis : '-';
    return (
        <span>
            {settlementBasis}
        </span>
    );
};

const getCellObPerils = (rowData) => {
    const perils = rowData.perils ? rowData.perils : '-';
    return (
        <span>
            {perils}
        </span>
    );
};

const getCellObType = (rowData) => {
    return (
        <span>
            {rowData.outBuildingType}
        </span>
    );
};

const getCellObClass = (rowData) => {
    return (
        <span>
            {rowData.buildingClass}
        </span>
    );
};

const getCellObDesc = (rowData) => {
    return (
        <span>
            {rowData.description}
        </span>
    );
};

const getCellObCoverageName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};

const getCellProduceDetailsName = (rowData) => {
    let coverageName = '';
    coverageName = rowData.name ? rowData.name : '-';
    coverageName = coverageName.replace('Scheduled Item - ', '');
    return (
        <span>
            {coverageName}
        </span>
    );
};

const getCellLivestockName = (rowData) => {
    let coverageName = '';
    coverageName = rowData.name? rowData.name : '-';
    return (
        <span>
            {coverageName}
        </span>
    );
};

const getCellFarmerTotalLimit = (rowData) => {
    const totalInsuredValue = rowData.totalInsuredValue? rowData.totalInsuredValue : '-'
    return (
        <span>
            {totalInsuredValue}
        </span>
    );
};

const removeArrayBracketsInString = (inputString) => {
    let outputStr = '';
    if (inputString) {
        outputStr = inputString.substring(1, inputString.length - 1);
    }
    return outputStr;
};

const getCellFarmerCoverages = (rowData) => {
    let farmCoverages = rowData.coverageNames;
    if (farmCoverages) {
        farmCoverages = farmCoverages.substring(1, farmCoverages.length - 1);

    return (
        <span>
            {removeArrayBracketsInString(rowData.coverageNames)}
        </span>
    );
    }
    else {
        return(
            <span> '-' </span>
        )
    }
};

const getCellBeneficiary = (rowData) => {
    const beneficiaryName = rowData.beneficiaryName? rowData.beneficiaryName : '-'
    return (
        <span>
            {beneficiaryName}
        </span>
    );
};

const getCellFarmerInsured = (rowData) => {
    const insuredName = rowData.insuredName? rowData.insuredName : '-'
    return (
        <span>
            {insuredName}
        </span>
    );
};

const getDiscount = (rowData) => {
    const category = rowData.category? rowData.category : '-'
    return (
        <span>
            {category}
        </span>
    );
};

const getDiscount1 = (items, index, property) => {
    return items['category'];
};

function PolicyFarmInformationComponent(props) {
    const { value: policyData } = props;
    const translator = useContext(TranslatorContext);
    const [openItems, setOpenItems] = useState([]);
    const [openExtension, setopenExtension] = useState([]);

    if (_.isEmpty(policyData) || policyData === undefined || policyData.productName !== 'Farm') {
        return null;
    }


    const policyLocations = useMemo(() => {

        const farmLocations = policyData.lobs.farm.locations;
        return farmLocations;
    }, [policyData]);

    const farmersDetail = useMemo(() => {
        const farmerList = policyData.lobs.farm.farmers;
        return farmerList;
    }, [policyData]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'myPolicyLocations') {
                return policyLocations;
            }
            return _.get(policyLocations, path);
        },
        [policyData]
    );

    const produceCoverages = (policyLocation) => {
        let produceCoverageArr = [];
        if(policyLocation.farmProduceCoverages){
            policyLocation.farmProduceCoverages.filter( (pc) => !pc.categoryCodeIdentifier).forEach((coverable) => {
                if(coverable ){
                    produceCoverageArr = produceCoverageArr.concat(coverable);
                }
            });
        }
        return produceCoverageArr;
    };

    const cropCoverages = (policyLocation) => {
        let produceCoverageArr = [];
        if(policyLocation.farmCropCoverages){
            policyLocation.farmCropCoverages.filter( (pc) => !pc.categoryCodeIdentifier).forEach((coverable) => {
                if(coverable ){
                    produceCoverageArr = produceCoverageArr.concat(coverable);
                }
            });
        }
        return produceCoverageArr;
    };

    const liveStockCoverages = (policyLocation) => {
        let produceCoverageArr = [];
        if(policyLocation.livestockCoverages){
            policyLocation.livestockCoverages.filter( (pc) => !pc.categoryCodeIdentifier).forEach((coverable) => {
                if(coverable ){
                    produceCoverageArr = produceCoverageArr.concat(coverable);
                }
            });
        }
        return produceCoverageArr;
    };

    const farmExtensionCoverages = (policyLocation) => {
        let produceCoverageArr = [];
        if(policyLocation.farmExtensionCoverages){
            policyLocation.farmExtensionCoverages.filter( (pc) => !pc.categoryCodeIdentifier).forEach((coverable) => {
                if(coverable ){
                    produceCoverageArr = produceCoverageArr.concat(coverable);
                }

            });
        }

        return produceCoverageArr;
    }


    //Show/Hide package details code -- Start--
    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(openItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                setOpenItems(openedItem);
            } else {
                setOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [openItems]
    );
    const toggleShowHideExtension = useCallback(
        (item) => {
            const openedItem = _.clone(openExtension);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                setopenExtension(openedItem);
            } else {
                setopenExtension(_.slice(openedItem, index, 0));
            }
        },
        [openExtension]
    );

    const getYesOrNo = (val) => {
        let result = '-';
        if (val === true) {
            result = 'Yes';
        } else if (val === false) {
            result = 'No';
        }
        return result;
    };

    const updateVisibility = useCallback((val) => {
        if (val && val.length > 0) {
            return true;
        }
        return false;
    }
    );

    const getOutBuildingDetails = (policyLocation) => {
        return _.flatMap((policyLocation.farmOutbuildings) , (building)=>{
            building.coverages.map((cov)=>{
                cov.outBuildingType = building.outBuildingType
                cov.description = building.description
                return cov

            })
            return building.coverages
        })
    };

    const getBICovs = (biCoverages) => {
        return biCoverages ? biCoverages.filter((pc) => pc.categoryCodeIdentifier !== undefined && pc.name !== 'Loss of Farm Income') : [];
    };

    const getBIScheduledItemsCovs = (biCoverages) => {
        return biCoverages ? biCoverages.filter((pc) => !pc.categoryCodeIdentifier) : [];
    };

    const getEquipmentMachineryCovs = (emCoverages) => {
        return emCoverages ? emCoverages.filter((pc) => pc.categoryCodeIdentifier !== undefined && pc.name !== 'Farm Machinery and Equipment') : []
    }

    const getEquipmentMachineryScheduledItemCovs = (emCoverages) => {
        return emCoverages ? emCoverages.filter((pc) => !pc.categoryCodeIdentifier) : [];
    }


    const generateFarmLocationTableOverrides = useCallback(() => {
        const overrides = policyLocations.map((policyLocation, index) => {
            return {
                [`packageDetailsDiv${index}`]: {
                    data: policyLocation.farmPackageDetails
                },
                [`locationCovDiv${index}`]: {
                    visible: updateVisibility(policyLocation.endorsementCoverages)
                },
                [`biCovDiv${index}`]: {
                    visible: getBICovs(policyLocation.biCoverages).length > 0
                },
                [`biScheduleDiv${index}`]: {
                    visible: getBIScheduledItemsCovs(policyLocation.biCoverages).length > 0
                },
                [`emCovDiv${index}`]: {
                    visible: getEquipmentMachineryCovs(policyLocation.equipmentMachineryCoverages).length > 0
                },
                [`emSchedulesDiv${index}`]: {
                    visible: getEquipmentMachineryScheduledItemCovs(policyLocation.equipmentMachineryCoverages).length > 0
                },
                [`obCovDiv${index}`]: {
                    visible: updateVisibility(policyLocation.farmOutbuildings)
                },
                [`produceCovDiv${index}`]: {
                    visible: updateVisibility(policyLocation.farmProduceCoverages)
                },
                [`cropCovDiv${index}`]: {
                    visible: updateVisibility(policyLocation.farmCropCoverages)
                },
                [`livestockCovDiv${index}`]: {
                    visible: updateVisibility(policyLocation.livestockCoverages)
                },
                [`farmExtensionsCovDiv${index}`]: {
                    visible: updateVisibility(policyLocation.farmExtensionCoverages)
                },
                [`farmerCovDiv${index}`]: {
                    visible: updateVisibility(farmersDetail)
                },
                [`locationEndorsementCoveragesTable${index}`]: {
                    data: policyLocation.endorsementCoverages
                },
                [`locationBiCoveragesTable${index}`]: {
                    data: getBICovs(policyLocation.biCoverages)
                },
                [`locationBiSchedulesTable${index}`]: {
                    data: getBIScheduledItemsCovs(policyLocation.biCoverages)
                },
                [`locationEmCoveragesTable${index}`]: {
                    data: getEquipmentMachineryCovs(policyLocation.equipmentMachineryCoverages)
                },
                [`locationEmSchedulesTable${index}`]: {
                    data: getEquipmentMachineryScheduledItemCovs(policyLocation.equipmentMachineryCoverages)
                },
                [`programDisc${index}`]: {
                    content: removeArrayBracketsInString(policyLocation.farmPackageDetails.discounts)
                },
                [`taxExempt${index}`]: {
                    value: getYesOrNo(policyLocation.farmPackageDetails.isTaxExempt)
                },
                [`farmPackageType${index}`]: {
                    value: `${policyLocation.farmPackageDetails.farmPackageType}` === 'BP7_NonPackageOffer_EY' ?
                        translator(messages.nonPackagedAgribusiness) : translator(messages.supremeAgribusiness)
                },
                [`fireGrade${index}`]: {
                    value: policyLocation.farmPackageDetails.fireGrade
                },
                [`farmProgramType${index}`]: {
                    value: policyLocation.farmPackageDetails.farmProgramType
                },
                [`locationOutBuildingTable${index}`]: {
                    data: getOutBuildingDetails(policyLocation)
                },
                [`locFarmProduceCoveragesTable${index}`]: {
                    data: produceCoverages(policyLocation)
                },
                [`locFarmCropCoveragesTable${index}`]: {
                    data: cropCoverages(policyLocation)
                },
                [`locFarmLivestockCoveragesTable${index}`]: {
                    data: liveStockCoverages(policyLocation)
                },
                [`farmExtCoveragesTable${index}`]: {
                    data: farmExtensionCoverages(policyLocation)
                },
                [`farmExCoverageName${index}`]: {
                    content: policyLocation.farmExtensionCoverages && policyLocation.farmExtensionCoverages.length > 0 ? policyLocation.farmExtensionCoverages[0].name : null
                },
                [`farmExCoverageValue${index}`]: {
                    value: policyLocation.farmExtensionCoverages && policyLocation.farmExtensionCoverages.length > 0 ? policyLocation.farmExtensionCoverages[0].limit : null
                },
                [`farmerAccidentTable${index}`]: {
                    data: farmersDetail
                },
                [`farmProgramDiscountTable${index}`]: {
                    data: policyLocation.discounts,
                    visible: !_.isEmpty(policyLocation.discounts)
                },
                [`additionalInterestTable${index}`]: {
                    data: policyLocation.additionalInterests,
                    visible: !_.isEmpty(policyLocation.additionalInterests)
                },
                [`contentDetailToggle${index}`]: {
                    icon: _.includes(openItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(openItems, index)
                        ? translator(messages.hidePackageCoverages)
                        : translator(messages.showPackageCoverages)
                },
                [`packageDetailsID${index}`]: {
                    visible: _.includes(openItems, index),
                    show: openItems
                },
                [`showContentToggleLink${index}`]: {
                    onClick: () => toggleShowHide(index)
                },
                [`showFarmContentToggleLink${index}`]: {
                    onClick: () => toggleShowHideExtension(index)
                },
                [`farmExtensionDetailToggle${index}`]: {
                    icon: _.includes(openExtension, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(openExtension, index)
                        ? translator(messages.hideExtension)
                        : translator(messages.showExtension)
                },
                [`farmextCovID${index}`]: {
                    visible: _.includes(openExtension, index),
                    show: openExtension
                },
            };
        });

        return Object.assign({}, ...overrides);
    }, [policyData, policyLocations, openItems, openExtension, toggleShowHide, translator, produceCoverages, liveStockCoverages]);

    const resolveCallbackMap = {
        getCellCoverageName: getCellCoverageName,
        getCellCoverageLimit: getCellCoverageLimit,
        getCellCoverageDeductible: getCellCoverageDeductible,
        getCellObCoverageName: getCellObCoverageName,
        getCellObType: getCellObType,
        getCellObDesc: getCellObDesc,
        getCellObClass: getCellObClass,
        getCellObPerils: getCellObPerils,
        getCellObSettlement: getCellObSettlement,
        getCellProduceDetailsName: getCellProduceDetailsName,
        getCellLivestockName: getCellLivestockName,
        getCellFarmerInsured: getCellFarmerInsured,
        getCellBeneficiary: getCellBeneficiary,
        getCellFarmerCoverages: getCellFarmerCoverages,
        getCellFarmerTotalLimit: getCellFarmerTotalLimit,
        getDiscount: getDiscount,
        getCellTypeName: getCellTypeName,
        getCellTypeScheduleNoOfHead: getCellTypeScheduleNoOfHead,
        getCellTypeScheduleValOfHead: getCellTypeScheduleValOfHead
    };

    const resolveComponentMap = {
        additionalinterestcomponent: AdditionalInterestComponent
    };

    const overrides = {
        repeatLocation: {
            data: policyLocations
        },
        ...generateFarmLocationTableOverrides()
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyLocations}
            overrideProps={overrides}
            resolveValue={readValue}
            callbackMap={resolveCallbackMap}
            componentMap={resolveComponentMap}
        />
    );
}

PolicyFarmInformationComponent.propTypes = {
    value: PropTypes.shape({})
};

PolicyFarmInformationComponent.defaultProps = {
    value: []
};

export default PolicyFarmInformationComponent;
